// Import controller interfaces.
import { IAppLinkController } from '../Interfaces/ControllerInterfacesBarrel';
// Import api models.
import {
	AppLink
} from '@app/models/api';
// Import app config.
import AppConfig from '@config/app';

export default class MockAppLinkController implements IAppLinkController {

	public constructor() {

	}

	public async get(): Promise<AppLink[]> {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				resolve(AppConfig.main_navigation_config);
			}, 1000);
		});
	}
}